import type { IconName } from '@dcc-erp/ui';

export interface NavItem {
  id: string;
  label: string;
  icon: IconName;
  badge?: string;
  permission?: string;
}

export interface NavSection {
  section: string;
  items: NavItem[];
}

export const NAV: NavSection[] = [
  {
    section: 'ภาพรวม',
    items: [{ id: 'dashboard', label: 'Dashboard', icon: 'dashboard' }],
  },
  {
    section: 'บัญชีแยกประเภท',
    items: [
      { id: 'coa', label: 'ผังบัญชี', icon: 'book' },
      { id: 'journal', label: 'บันทึกบัญชี', icon: 'journal' },
      { id: 'ledger', label: 'บัญชีแยกประเภท', icon: 'ledger' },
      { id: 'fixedasset', label: 'สินทรัพย์ถาวร', icon: 'factory' },
      { id: 'lva', label: 'ของมูลค่าน้อย (LVA)', icon: 'factory' },
      { id: 'prepaid', label: 'ค่าใช้จ่ายล่วงหน้า', icon: 'calendar' },
      { id: 'lease', label: 'สัญญาเช่า TFRS 16', icon: 'branch' },
      { id: 'glsched', label: 'กระทบยอด GL & ประกอบบัญชี', icon: 'check' },
      { id: 'cip', label: 'งานระหว่างก่อสร้าง (CIP)', icon: 'factory' },
      { id: 'empben', label: 'TAS 19 ผลประโยชน์พนักงาน', icon: 'eye' },
      { id: 'opcontract', label: 'สัญญาดำเนินงาน', icon: 'journal' },
    ],
  },
  {
    section: 'ลูกหนี้ / เจ้าหนี้',
    items: [
      { id: 'ar', label: 'ลูกหนี้การค้า', icon: 'ar' },
      { id: 'ap', label: 'เจ้าหนี้การค้า', icon: 'ap' },
      { id: 'suppliers', label: 'ผู้ขาย (Suppliers)', icon: 'branch' },
      { id: 'pettycash', label: 'เงินสดย่อย', icon: 'branch' },
      { id: 'advance', label: 'เงินทดรองจ่าย', icon: 'ap' },
      { id: 'accrual', label: 'ประมาณการค่าใช้จ่าย', icon: 'refresh' },
      { id: 'payreq', label: 'ขออนุมัติจ่ายเงิน', icon: 'ap' },
    ],
  },
  {
    section: 'เอกสาร AI',
    items: [
      {
        id: 'doc-ingest',
        label: 'ตรวจเอกสาร AI',
        icon: 'search',
      },
    ],
  },
  {
    section: 'รายงานและภาษี',
    items: [
      { id: 'reports', label: 'งบการเงิน', icon: 'reports' },
      { id: 'vat', label: 'ภาษีมูลค่าเพิ่ม', icon: 'tax' },
      { id: 'wht', label: 'ภาษีหัก ณ ที่จ่าย', icon: 'tax' },
      { id: 'taxrecon', label: 'กระทบยอดภาษี GL ↔ แบบ', icon: 'check' },
      { id: 'taxadj', label: 'ภาษีนิติบุคคล (ภ.ง.ด.50)', icon: 'tax' },
      { id: 'consol', label: 'งบการเงินรวม', icon: 'reports' },
      { id: 'reclass', label: 'รายการจัดประเภท (Reclass)', icon: 'refresh' },
      { id: 'ppemove', label: 'PPE Movement (TAS 16)', icon: 'factory' },
      { id: 'cfforecast', label: 'Cashflow Forecast', icon: 'bank' },
      { id: 'fxreval', label: 'FX Revaluation (TAS 21)', icon: 'tax' },
      { id: 'proptax', label: 'ภาษีที่ดิน & ป้าย', icon: 'tax' },
      { id: 'recon', label: 'กระทบยอดธนาคาร', icon: 'bank' },
    ],
  },
  {
    section: 'ระบบ',
    items: [
      { id: 'master', label: 'Master Data', icon: 'settings' },
      { id: 'settings/coa', label: 'ตั้งค่าผังบัญชี', icon: 'book' },
      { id: 'settings/account-mapping', label: 'ตั้งค่าบัญชีอ้างอิง', icon: 'book' },
      {
        id: 'settings/roles',
        label: 'บทบาท & สิทธิ์',
        icon: 'settings',
      },
      {
        id: 'settings/users',
        label: 'ผู้ใช้ & บทบาท',
        icon: 'settings',
      },
      {
        id: 'settings/approval-matrix',
        label: 'เกณฑ์อนุมัติ',
        icon: 'settings',
      },
      { id: 'settings/audit', label: 'บันทึกการตรวจสอบ', icon: 'eye' },
      { id: 'asset-categories', label: 'หมวดสินทรัพย์', icon: 'factory' },
      { id: 'pclose', label: 'ปิดงวดบัญชี', icon: 'check', badge: '05/26' },
    ],
  },
];
